<template>
    <main>
        <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
            <div class="col-lg-5">
                <div class="card bg-secondary shadow border-0">
                <div class="card-header bg-white pb-5">
                    <div class="text-muted text-center mb-3">
                    <small>เข้าสู่ระบบด้วย</small>
                    </div>
                    <div class="btn-wrapper text-center">
                    <a :href="linklinelogin" class="btn btn-neutral btn-icon">
                        <span class="btn-inner--icon">
                        <img src="https://www.donelike.com/images/lineicon.png">
                        </span>
                        <span class="btn-inner--text">Line</span>
                    </a>
                    </div>
                </div>
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                    <small>หรือเข้าสู่ระบบด้วยอีเมล</small>
                    </div>
                    <form role="form">
                    <div class="form-group mb-3">
                        <div class="input-group input-group-alternative">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                        </div>
                        <input class="form-control" placeholder="อีเมล" type="email">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-alternative">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                        </div>
                        <input class="form-control" placeholder="รหัสผ่าน" type="password">
                        </div>
                    </div>
                    <div class="custom-control custom-control-alternative custom-checkbox">
                        <input class="custom-control-input" id=" customCheckLogin" type="checkbox">
                        <label class="custom-control-label" for=" customCheckLogin">
                        <span>จำไว้ในระบบ</span>
                        </label>
                    </div>
                    <div class="text-center">
                        <button type="button" class="btn btn-primary my-4"><i class="fa fa-sign-in"></i> เข้าสู่ระบบ</button>
                    </div>
                    </form>
                </div>
                </div>
                <div class="row mt-3">
                <div class="col-6">
                    <a href="#" class="text-light">
                    <small><i class="fa fa-info-circle" aria-hidden="true"></i> ลืมรหัสผ่าน</small>
                    </a>
                </div>
                <div class="col-6 text-right">
                    <router-link to="/register#เดียวต้องทำล๊อคอินไลน์แล้วส่งข้อมูลมาเพื่อกรอกข้อให้ครบเพื่อสมัคร" class="text-light">
                    <small><i class="fa fa-user-plus" aria-hidden="true"></i> สมัครบัญชีใหม่</small>
                    </router-link>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
    </main>
</template>


<script>
import UserStore from '@/stores/UserStore'
export default {
  name: 'Login',
  components: {
    // HelloWorld
  },
  data(){
      return {
          linklinelogin:null
      }
  },
  methods: {
    LoadLinklinelogin: async function() {
      await UserStore.dispatch('getLoginLine')
      if(UserStore.state.lineloginline.status){
        this.linklinelogin = UserStore.state.lineloginline.url;
      }
    },

  },
  async mounted () {
    await this.LoadLinklinelogin()
    // console.log(this.linklinelogin);
  },
}
</script>